<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { timestampToTime } from '@/helpers';
import { useRouter, useRoute } from 'vue-router';
import { useFixturesStore } from '@/stores/fixtures';
import { useI18n } from 'vue-i18n';

const { t, te } = useI18n()
const props = defineProps({
    event: Object,
})
const router = useRouter()
const route = useRoute()
const fixtures = useFixturesStore()
const { getSport , getLiveEventsBySport} = storeToRefs(fixtures)
const si = computed(() => route.params.si)
const closeModal = () =>{
    router.back();
}
const selectEvent = (event) => {
   const url = `/in-play/${event.i}`
   router.push(url)
}
const competitionName = computed(() => (competition) => {
  return te(`competitions.${competition.i}`)
    ? t(`competitions.${competition.i}`)
    : competition.cn
})
</script>

<template>
    <div class="fixed w-full h-full top-0  gradient-bg">
        <div class="flex px-4 w-full justify-between text-white items-center h-[50px] border-b border-gray-600/50">
            <p></p>
            <p class="text-center font-bold">
                {{ $te(`sports.${si}`) ? $t(`sports.${si}`) : getSport(si)?.sn }}
            </p>
            <div class="flex items-center cursor-pointer" @click="closeModal">
                <img src="/close.svg" class="w-4 h-4"/>
            </div>
        </div>

        <div class="flex-1  overflow-y-auto container">
            <div class="text-white">
                <div v-for="competition in getLiveEventsBySport(si)" class="border-b border-gray-600/50">
                    <p class="league-name text-center justify-center font-bold py-4">{{ competitionName(competition) }} </p>
                    <ul class="list-none divide-y divide-neutral-500/25">
                        <li v-for="event in competition.events">
                            <div @click="selectEvent(event)" class="grid grid-cols-5 items-end gap-2 justify-center p-4 hover:bg-[var(--color-white15)] cursor-pointer">
                                <span class="font-bold w-full col-span-2 ht-name">{{ event?.h }} </span>
                                <div class="flex flex-col items-center w-full col-span-1">
                                    <p class="text-center text-sm"> {{ timestampToTime(event.t) }}</p>
                                    <p class="text-yellow-500 font-bold text-lg flex items-center gap-2"><span>{{event.inf?.res?.split('-')[0] }} </span> <span>{{ event.inf?.res?.split('-')[1]}}</span></p>   
                                </div>
                                <span class="font-bold w-full col-span-2 ht-name"> {{ event?.a }} </span>   
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.league-name{
    color: var(--hm-selected);
}
.gradient-bg {
  background-image: linear-gradient(160deg,#364D3C 0%, var(--color-grey3) 400px)
}
.ht-name{
    display: -webkit-box;
    -webkit-line-clamp: 1; 
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal; 
    word-break: break-word; 
    text-align: center;
}
.container {
  height: calc(100% - 50px);
}
</style>